import { defineMessages } from 'react-intl';

export default defineMessages({
    termsOfUse: {
        id: 'tdic.tnc.common.Terms of use',
        defaultMessage: 'Terms of Use'
    },
    autopay: {
        id: 'tdic.tnc.common.Autopay',
        defaultMessage: 'Autopay'
    },
});
